export const selectHasRsvpd = ({rsvp}) => rsvp?.hasRsvpd;
